export const APP_ID = 'njzqsi3i';

export const MILLISECONDS_PER_SECOND = 1000;

export const TEST_ID = 'chatSupport';
